/**
 * Excluding enroll calls - for example:
 *  - getIndividualExtendedInfo
 */

export enum CRMCall {
  getIndividualExtendedInfo,
  getCountryList,
  getAccounts,
  getAccountInfo,
  getAccountDetails,
  getAccountsSummary,
  internalTransfer,
  getLegalDeclarations,
  getTradingPlatforms,
  updateIndividualTransitionToForVerification,
  updateIndividualTransitionToForActive,
  getIndividualUserName,
  changeIndividualUserName,
  searchTradingPlans,
  refreshSubscription,
}

export enum LegalDeclarations {
  ClientAgreement = 'Client Agreement',
  GeneralTerms = 'General Terms and Conditions',
  PrivacyPolicy = 'Privacy Policy',
}

export type UploadDocumentFiles = {
  file_name: string,
  file_data: string,
}

export type CRMCallName = keyof typeof CRMCall
